import { DialogComponent } from "./chunk-GQWK4RJY.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Modal/Modal.Header.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Header = _a => {
  var _b = _a,
    {
      className,
      children
    } = _b,
    rest = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */jsx(DialogComponent.Header, __spreadProps(__spreadValues({
    className: clsx("pd-modal__header", className)
  }, rest), {
    children
  }));
};
var Modal_Header_default = Header;
export { Modal_Header_default };